import api, { unwrap } from './client';
import type { ErpModule } from '@/api/platform.api';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { NotificationRequest, NotificationResponse } from '@/types/notification';

export type NotificationListParams = SearchParams & { module?: ErpModule };

export const notificationsApi = {
  list: (params?: NotificationListParams) =>
    unwrap(api.get<ApiResponse<PageResponse<NotificationResponse>>>('/v1/notifications', { params })),

  unreadCount: (module?: ErpModule) =>
    unwrap(
      api.get<ApiResponse<{ count: number }>>('/v1/notifications/unread-count', {
        params: module ? { module } : undefined,
      }),
    ),

  create: (body: NotificationRequest) =>
    unwrap(api.post<ApiResponse<NotificationResponse>>('/v1/notifications', body)),

  markRead: (id: number) =>
    unwrap(api.patch<ApiResponse<NotificationResponse>>(`/v1/notifications/${id}/read`)),

  markAllRead: (module?: ErpModule) =>
    unwrap(
      api.patch<ApiResponse<null>>('/v1/notifications/read-all', null, {
        params: module ? { module } : undefined,
      }),
    ),
};
